
export default function checkScroll() {
    if ($(".plugin__nav").length) {
        let height = $(".plugin__header").height()
        if ($(window).scrollTop() >= height) {
            $(".plugin__fixed").addClass("fixed")
            $(".plugin__content").addClass("fixed")
        } else {
            $(".plugin__fixed").removeClass("fixed")
            $(".plugin__content").removeClass("fixed")
        }
    }
}